const PerformanceConstants = {
  GET_FILTER_PERFORMANCE_LOG_SUCCESS: "GET_FILTER_Performance_LOG_SUCCESS",
  GET_FILTER_PERFORMANCE_LOG_FAILURE: "GET_FILTER_PERFORMANCE_LOG_FAILURE",
  DEL_PERFORMANCE_LOG_SUCCESS: "DEL_PERFORMANCE_LOG_SUCCESS",
  DEL_PERFORMANCE_LOG_FAILURE: "DEL_PERFORMANCE_LOG_FAILURE",
  DEL_MUL_PERFORMANCE_LOG_SUCCESS: "DEL_MUL_PERFORMANCE_LOG_SUCCESS",
  DEL_MUL_PERFORMANCE_LOG_FAILURE: "DEL_MUL_PERFORMANCE_LOG_FAILURE",
};
export default PerformanceConstants;
